export default {
  have_account: '¿Tienes una cuenta?',
  sign_in: 'Iniciar sesión',
  sign_in_description: 'para usar tus puntos e información guardada',
  join_free: 'Únete gratis',
  join_description: '— gana recompensas en cada pedido',
  join_description_with_discount: `— gana recompensas como hasta <highlight>{{max_discount}} de descuento</highlight> en cada pedido`,
  join_description_with_product_and_discount: `— gana recompensas como {{product_name}} gratis y hasta <highlight>{{max_discount}} de descuento</highlight> en cada pedido`,
  demo_mode: 'Modo demo',
};
